export var SearcherTabsVariant;
(function(SearcherTabsVariant) {
    SearcherTabsVariant["Default"] = 'default';
    SearcherTabsVariant["Buttons"] = 'buttons';
})(SearcherTabsVariant || (SearcherTabsVariant = {}));

//# sourceMappingURL=types.js.map